function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';

var SvgSprite = function SvgSprite(_ref) {
  var id = _ref.id,
      _ref$sprite = _ref.sprite,
      sprite = _ref$sprite === void 0 ? "".concat(process.env.BASE_URL, "/builds/sprite.svg") : _ref$sprite,
      size = _ref.size,
      sizeDesktop = _ref.sizeDesktop,
      sizeMobile = _ref.sizeMobile,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'icon' : _ref$className,
      additionalClassName = _ref.additionalClassName,
      additionalClassNameDesktop = _ref.additionalClassNameDesktop,
      additionalClassNameMobile = _ref.additionalClassNameMobile,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props;
  var isDesktop = useMediaIsDesktop();

  var getCurrentSize = function getCurrentSize() {
    if (isDesktop && sizeDesktop) {
      return sizeDesktop;
    }

    if (!isDesktop && sizeMobile) {
      return sizeMobile;
    }

    return size;
  };

  var newProps = _objectSpread({}, props);

  newProps.width = getCurrentSize() || width;
  newProps.height = getCurrentSize() || height;
  newProps['aria-hidden'] = true;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: classNames(className, additionalClassName, _defineProperty({}, additionalClassNameDesktop, isDesktop && additionalClassNameDesktop), _defineProperty({}, additionalClassNameMobile, !isDesktop && additionalClassNameDesktop))
  }, newProps), /*#__PURE__*/React.createElement("use", {
    href: "".concat(sprite, "#").concat(id)
  }));
};

export default SvgSprite;